<div class="flex-row flex">
    @if (isBuildingConsultant.value) {
        <cb-my-leads-side-panel
            class="cb-margin flex-row"
            [currentLeadId]="currentLeadId"
            (leadSelected)="leadSelected($event)"
            [leadUpdated]="leadUpdated"
        >
        </cb-my-leads-side-panel>
    }
    @if (currentLeadId) {
        <cb-lead-edit
            class="cb-margin flex"
            style="overflow: hidden"
            [id]="currentLeadId"
            (leadChanged)="updateLead($event)"
            [isBuildingConsultant]="isBuildingConsultant.value"
        >
        </cb-lead-edit>
    }
    @if (!currentLeadId) {
        <div class="cb-margin-2x flex-col flex">
            <cb-info-message
                message="No Lead has been selected"
                iconClass="cb-grey"
            ></cb-info-message>
        </div>
    }
    @if (lead) {
        <cb-lead-side-bar-card-new [lead]="lead" class="cb-margin"> </cb-lead-side-bar-card-new>
    }
</div>
